import { Component, inject, InjectionToken, OnInit } from '@angular/core';
import packageInfo from 'package.json';
import { TranslateDirective } from '@ngx-translate/core';
import { EnvironmentService } from '@mwe/services';
import { ENVIRONMENT_SERVICE_TOKEN } from '@mwe/constants';
export const PAGE_RIBBON_ON_CLICK_HANDLER = new InjectionToken<() => void>('Page Ribbon On Click');
@Component({
  selector: 'mwe-page-ribbon',
  template: `
    @if (ribbonEnv !== 'prod') {
      <div class="ribbon" (click)="openMockModal()">
        <span translate="global.ribbon.{{ ribbonEnv }}">{{ ribbonEnv }}</span>
        <span class="version">{{ version }}</span>
      </div>
    }
  `,
  styleUrls: ['page-ribbon.scss'],
  imports: [TranslateDirective],
})
export class PageRibbonComponent implements OnInit {
  private readonly environmentService = inject(ENVIRONMENT_SERVICE_TOKEN) as EnvironmentService;
  private readonly onClickHandler = inject(PAGE_RIBBON_ON_CLICK_HANDLER, { optional: true });

  ribbonEnv: string;
  version: string;

  ngOnInit(): void {
    this.ribbonEnv = this.environmentService.getEnvironment().env;
    this.version = packageInfo.version;
  }

  openMockModal() {
    if (this.onClickHandler) {
      this.onClickHandler();
    }
  }
}
